import { Check } from "@mui/icons-material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "components/mui-core";
import { useState } from "react";

const useStyles = makeStyles()({
  codeContainer: {
    position: "relative",
    borderRadius: "5px",
    backgroundColor: "#e9e6ff",
    padding: "20px 30px",
    border: "1px solid darkblue",
    overflow: "visible",
  },
  copyButton: {
    position: "absolute",
    top: "-10px",
    right: "10px",
    zIndex: 10,
    fontSize: "10px",
    border: "1px solid darkblue",
    backgroundColor: "#d8d3ff",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: "#c2baff",
    },
  },
  codeBlock: {
    fontFamily: "monospace",
  },
});

interface Props {
  code: string;
}

export const CodeBlock = ({ code }: Props) => {
  const { classes } = useStyles();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className={classes.codeContainer}>
      <IconButton
        size="small"
        className={classes.copyButton}
        onClick={copyToClipboard}>
        {!copied ? (
          <>
            <FileCopyIcon
              sx={{ width: "13px", height: "13px", marginRight: "5px" }}
            />
            Copy
          </>
        ) : (
          <>
            <Check sx={{ width: "13px", height: "13px", marginRight: "5px" }} />
            Copied to clipboard
          </>
        )}
      </IconButton>
      <code className={classes.codeBlock}>{code}</code>
    </div>
  );
};
